module.exports = __webpack_public_path__ + "img/cn-pro-j-t.82283952.png";